/** @jsx jsx **/
import { Box, Flex, jsx, Heading, Text } from 'theme-ui'
import { FC } from 'react'
import Img, { FluidObject } from 'gatsby-image'
import theme from '~/gatsby-plugin-theme-ui'

type GridPhotoWithListItemListType = {
  title: string
  description: string
}

type GridPhotoWithListItemType = {
  image1: FluidObject
  image2?: FluidObject
  list: GridPhotoWithListItemListType[]
}

const GridPhotoWithListItem: FC<GridPhotoWithListItemType> = ({ image1, image2, list }) => {
  return (
    <Flex
      sx={{
        mb: [50, null, 100],
        flexWrap: ['wrap', null, 'nowrap'],
        alignItems: 'center',
        ':nth-child(even)': {
          '> *:first-child': {
            order: [null, null, 1],
            mr: 0,
            ml: [null, null, 180],
          },
        },
      }}
    >
      <Box
        sx={{
          width: '100%',
          mr: [null, null, 180],
          mb: [60, null, 0],
        }}
      >
        <Box
          sx={{
            position: 'relative',
          }}
        >
          <Img
            fluid={image1}
            sx={{
              maxWidth: image2 ? '70%' : '100%',
              maxHeight: 800,
              ml: 'auto',
            }}
          />
          {image2 && (
            <Img
              fluid={image2}
              sx={{
                position: 'absolute !important',
                width: '50%',
                maxHeight: 432,
                top: '50%',
                transform: 'translateY(-50%)',
              }}
            />
          )}
        </Box>
      </Box>
      <Box
        sx={{
          width: [null, null, 423],
          minWidth: [null, null, 423],
          ul: {
            pl: 0,
            listStyle: 'none',
            li: {
              '+ li': {
                mt: [39, null, null, 72],
              },
            },
          },
        }}
      >
        <ul>
          {list.map(item => (
            <li key={item.title}>
              <Heading
                as="h3"
                variant="title5"
                sx={{
                  variant: 'variants.mark',
                }}
              >
                {item.title}
              </Heading>
              <Text variant="small" color={theme.colors.muted}>
                {item.description}
              </Text>
            </li>
          ))}
        </ul>
      </Box>
    </Flex>
  )
}

export default GridPhotoWithListItem
